import { Field, Float, ID, InputType, ObjectType } from 'type-graphql'
import { Company } from '../company/Company'
import { User } from './User'

@ObjectType()
@InputType('UserAndCompanyInput')
export class UserAndCompany {
  @Field(() => ID)
  _id: string

  @Field(() => Company)
  company: Company

  @Field(() => [User])
  users: User[]

  @Field(() => [UserAndCompany])
  subCompanies: UserAndCompany[]

  @Field(() => Company)
  parentCompany: Company

  @Field(() => Float)
  count: number

  @Field(() => String)
  chosen: boolean
}
